import FacebookLogo from './FacebookLogo';

export default FacebookLogo;
